export const EGarnishmentStatus = {
  Active: "active",
  Satisfied: "satisfied",
  Modified: "modified",
  Vacated: "vacated",
  Cancelled: "cancelled",
} as const;

export type EGarnishmentStatus =
  (typeof EGarnishmentStatus)[keyof typeof EGarnishmentStatus];
